import { RemoteExportProfessionalsDailyWorkloadExcel } from 'data/usecases';
import { ExportProfessionalsDailyWorkloadExcelUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsDailyWorkloadExportExcel } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportProfessionalsDailyWorkloadExcel =
  (): ExportProfessionalsDailyWorkloadExcelUseCaseInterface =>
    new RemoteExportProfessionalsDailyWorkloadExcel(
      makeApiUrlProfessionalsDailyWorkloadExportExcel(),
      makeAxiosHttpClient(),
    );
